import { render } from "./PriceRangeSlider.vue?vue&type=template&id=eb54067c&ts=true"
import script from "./PriceRangeSlider.vue?vue&type=script&lang=ts"
export * from "./PriceRangeSlider.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/damianowaga/Projects/mytechaccessories/wp-content/themes/mytechaccessories/addons/packages/catalog/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__